import React from "react";
import styled, { css } from "styled-components";

const Text = styled.span`
  font-weight: ${({ bold }) => (bold ? "bold" : "normal")};

  ${(props) => {
    if (props.type === "h1") {
      return css`
        font-size: 3rem;
        font-weight: bold;
      `;
    } else if (props.type === "h2") {
      return css`
        font-size: 2rem;
        font-weight: bold;
      `;
    } else if (props.type === "h3") {
      return css`
        font-size: 1.5rem;
        font-weight: bold;
      `;
    } else if (props.type === "h4") {
      return css`
        font-size: 1.25rem;
        font-weight: bold;
      `;
    } else if (props.type === "large") {
      return css`
        font-size: 1.125rem;
      `;
    } else if (props.type === "medium") {
      return css`
        font-size: 1rem;
      `;
    } else if (props.type === "small") {
      return css`
        font-size: 0.875rem;
      `;
    }
  }};

  font-family: ${({ uiKitConfiguration }) => uiKitConfiguration.font_family};
`;

export default Text;
